import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import HomePage from "@/pages/public/HomePage";
import BookingPage from "@/pages/public/BookingPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="admin-scope flex items-center justify-center">
        <p className="font-mono-label text-[#C5A059]">Cargando…</p>
      </div>
    );
  if (!user) return <Navigate to="/admin" replace />;
  return children;
};

function App() {
  useEffect(() => { document.title = "Yocaira Abreu Photography"; }, []);
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/reservar" element={<BookingPage />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <Protected>
                    <AdminDashboard />
                  </Protected>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
